const getEndpointUrl = () => {
  return import.meta.env.VITE_API_URL !== undefined
    ? import.meta.env.VITE_API_URL
    : 'https://dashboard.revix.com/';
};

const getCDNUrl = () => {
  return import.meta.env.VITE_CDN_URL !== undefined
    ? import.meta.env.VITE_CDN_URL
    : 'https://revix-prod-cdn-public.azureedge.net/';
};

const getSiteUrl = () => {
  return import.meta.env.VITE_BASE_URL !== undefined
    ? import.meta.env.VITE_BASE_URL
    : 'https://app.edge.altify.com/';
};

export const getMarketingUrl = () => {
  return import.meta.env.VITE_MARKETING !== undefined
    ? import.meta.env.VITE_MARKETING
    : 'https://altify.com/';
};

export default {
  getEndpointUrl,
  getCDNUrl,
  getSiteUrl,
  getMarketingUrl,
};
